export default "__VITE_ASSET__43I9QZfj__"